<p>daily-driver-checks-graph works!</p>
